import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import axios from 'axios/index';
import {
    createDateTimeObject,
    generateUUID
} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import LocationsWithIdsSelectInput from '../components/LocationsWithIdsSelectInput';
import Config from '../messages';
import FuseTheme from '../global/theme';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ContentChange from 'material-ui/svg-icons/content/create';
import ContentCheck from 'material-ui/svg-icons/action/check-circle';
import ContentCancel from 'material-ui/svg-icons/navigation/cancel';

/**
 * A component for displaying and processing a Transfer change of Location.
 *
 */
class TransferChangeLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            record: {},
            notificationMessage: '',
            notificationOpen: false,
            showLocationSelect: false,
            selectedLocation: null,
            showSuccessMessage: null,
            submitting: false,
            validLocation: false,
        };

        this.handleChangeLocation = this.handleChangeLocation.bind(this);
        this.activateComponent = this.activateComponent.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record !== this.props.record) {
            this.setState({
                record: nextProps.record
            });
        }
    }

    // Handle event to display Location select
    handleDisplayLocationSelect = () => {
        this.setState({
            showLocationSelect: true,
        });
        this.activateComponent(true);
    };

    // Handle event to hide Location select
    handleHideLocationSelect = () => {
        this.setState({
            notificationOpen: false,
            showLocationSelect: false,
        });
        this.activateComponent(false);
    };

    // Handle event to store Location selection and validity
    handleLocationSelection = (event, index, value) => {
        this.setState({
            selectedLocation: value,
            validLocation: !!(value)
        });
    };

    // Handle event to set new Location
    handleChangeLocation = () => {
        const location = this.state.selectedLocation;
        this.setState({
            submitting: true
        });
        this.sendData(location);
    };

    // Send event to toggle other component
    activateComponent = (activate) => {
        this.props.onActivateComponent(activate);
    };

    // Post a Location Change for this Transfer
    sendData(location) {
        // Assemble the URI
        const params = {
            location: location,
            transfer_id: this.props.record.transfer_id,
            "client": {
                system: localStorage.getItem('system'),
                location: Config.fuse.client.location,
                register: Config.fuse.client.register,
                user: localStorage.getItem('email'),
                device: Config.fuse.client.device,
                version: Config.fuse.admin.version
            },
            "pkg_date_time": createDateTimeObject(),
            "pkg_uuid": generateUUID(),
            "pkg_version": 4,
        };
        const resource = inventoryResources.TransferChangeLocation.UPDATE(params);

        // Post the data
        import ('../shared/serverFunctions').then(functions => {
            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }
            axios({
                method: 'post',
                url: resource.uri,
                headers: functions.getPostHeaders()
            }).then((result) => {
                if (result.data.payload) {
                    this.setState({
                        notificationMessage: 'Successfully changed Location of Transfer.',
                        notificationOpen: true,
                        showSuccessMessage: true,
                        submitting: false
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                this.setState({
                    notificationOpen: false,
                    submitting: false
                });
            });
        });
    }

    getBasePathUpOne() {
        const {basePath} = this.props;
        return basePath
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    render() {
        const {
            position,
            record,
            showComponent
        } = this.props;

        const styles = {
            buttonCard: {
                flex: '0 1 50%',
                display: 'inline-block',
                width: 'calc(50% - 0.5em)',
                margin: '1em 1em 1em 0',
                verticalAlign: 'top',
            },
            buttonCardLast: {
                marginRight: 0,
            },
            cardText: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            cardTextBelow: {marginTop: '1em'},
            select: {
                margin: '0 0 1em 0',
            },
            loader: {
                display: 'inline-block',
                margin: '0 0 0 8px',
                verticalAlign: 'middle',
            },
            notification: {
                backgroundColor: FuseTheme.palette.primary1Color
            },
        };

        const cardStyle = (position === 'right') ? {...styles.buttonCard, ...styles.buttonCardLast} : styles.buttonCard;

        const buttonPath = this.getBasePathUpOne();

        return (
            <Card className="buttonCard" style={cardStyle}>
                <CardHeader title="Change Location"/>
                <CardText>
                    <span style={styles.cardText}>
                        Click <strong>Change Location</strong> to change the destination of this transfer from this
                        Location ({record.location_to}) to another.
                    </span>
                    {/* Change Location button */}
                    {!this.state.showLocationSelect &&
                    <div>
                        <RaisedButton
                            primary
                            label="Change Location"
                            icon={<ContentChange/>}
                            onClick={this.handleDisplayLocationSelect}
                            disabled={!showComponent}
                        />
                    </div>
                    }

                    {/* Change Location select, Submit, Cancel */}
                    {this.state.showLocationSelect &&
                    <div>
                        <div style={styles.select}>
                            <Field name="change_location_id"
                                   component={LocationsWithIdsSelectInput}
                                   formName="locationChangeForm"
                                   label="Select a new Location"
                                   onSelectChange={this.handleLocationSelection}
                            />
                        </div>
                        <RaisedButton
                            primary
                            label="Choose Location"
                            icon={<ContentCheck/>}
                            onClick={this.handleChangeLocation}
                            disabled={!this.state.validLocation || this.state.showSuccessMessage}
                        />
                        <FlatButton
                            primary
                            label="Cancel"
                            icon={<ContentCancel/>}
                            onClick={this.handleHideLocationSelect}
                            disabled={this.state.showSuccessMessage}
                        />
                        {this.state.submitting &&
                        <CircularProgress
                            size={20}
                            thickness={2}
                            style={styles.loader}
                        />
                        }

                        {/* Success messaging and List links */}
                        {this.state.showSuccessMessage &&
                        <div>
                            <span style={{...styles.cardText, ...styles.cardTextBelow}}>
                                This Transfer's Destination has been changed.
                            </span>
                            <FlatButton
                                primary
                                label="Return to Incoming Transfers"
                                containerElement={<Link to={buttonPath}/>}
                            />
                        </div>
                        }
                        <Snackbar
                            open={this.state.notificationOpen}
                            message={this.state.notificationMessage}
                            autoHideDuration={3000}
                            bodyStyle={styles.notification}
                        />
                    </div>
                    }
                </CardText>
            </Card>
        )
    }
}

TransferChangeLocation.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string.isRequired,
    record: PropTypes.object,
    onActivateComponent: PropTypes.func,
    onClickChangeLocation: PropTypes.func,
    position: PropTypes.string,
    showComponent: PropTypes.bool,
};

TransferChangeLocation.defaultProps = {
    addField: true,
    position: 'left',
    showComponent: true,
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'locationChangeForm',
        enableReinitialize: true,
    })
);

export default enhance(TransferChangeLocation);



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferChangeLocation.js